<div class="border-b border-gray-300 p-4 my-3" [formGroup]="ownerFilterForm">
  <div class="flex flex-row">

    <div class="sm:col-span-4">
      <label for="id" class="block text-sm/6 font-medium text-gray-900">ID</label>
      <div class="mt-2">
        <input id="id" formControlName="id" type="text" placeholder="Enter ID"
          class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6">
      </div>
    </div>

    <div class="sm:col-span-4">
      <label for="firstname" class="block text-sm/6 font-medium text-gray-900">First Name</label>
      <div class="mt-2">
        <input id="firstname" formControlName="firstname" type="text" placeholder="Name"
          class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6">
      </div>
    </div>

    <div class="sm:col-span-4 mx-2">
      <label for="lastname" class="block text-sm/6 font-medium text-gray-900">Last Name</label>
      <div class="mt-2">
        <input id="lname" formControlName="lastname" type="text" placeholder="Last name"
          class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6">
      </div>
    </div>

    <div class="sm:col-span-4 mx-2">
      <label for="dateofbirth" class="block text-sm/6 font-medium text-gray-900">Date of birth</label>
      <div class="mt-2">
        <input id="lname" formControlName="dateofbirth" type="text" placeholder="Date of birth"
          class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6">
      </div>
    </div>

    <div class="sm:col-span-4 mx-2">
      <label for="sexvalue" class="block text-sm/6 font-medium text-gray-900">Gender</label>
      <div class="mt-2">
        <input id="lname" formControlName="sexvalue" type="text" placeholder="Gender"
          class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6">
      </div>
    </div>

    <div class="sm:col-span-4 mx-2">
      <label for="mobilenumber" class="block text-sm/6 font-medium text-gray-900">Mobile Number</label>
      <div class="mt-2">
        <input id="lname" formControlName="mobilenumber" type="text" placeholder="Mobile Number"
          class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6">
      </div>
    </div>

    <div class="sm:col-span-4 mx-2">
      <label for="education" class="block text-sm/6 font-medium text-gray-900">Qualification</label>
      <div class="mt-2">
        <input id="lname" formControlName="education" type="text" placeholder="Qualification"
          class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:outline-indigo-600 sm:text-sm/6">
      </div>
    </div>

    <div class="sm:col-span-4 mx-2" >

    </div>
  </div>

  <div class="flex flex-row-reverse mt-4 px-4 sp pe-10">
    <button (click)="onSubmit()" class="bg-transparent hover:bg-green-500 text-green-700 font-semibold hover:text-white py-2 px-4 border border-green-500 hover:border-transparent rounded mx-2">
      Apply
    </button>
    <button (click)="onReset()" class="bg-transparent hover:bg-red-500 text-red-700 font-semibold hover:text-white py-2 px-4 border border-red-500 hover:border-transparent rounded mx-2">
      Reset
    </button>
  </div>
</div>
